var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_143_304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 35C70 54.3302 54.3302 70 35 70C15.6698 70 0 54.3302 0 35C0 15.6698 15.6698 0 35 0C54.3302 0 70 15.6698 70 35Z",
    fill: "#ABA9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9576 33.8977C46.1727 31.4763 48.2555 27.6289 48.2555 23.3036C48.2555 15.995 42.3093 10.0488 35.0002 10.0488C27.6916 10.0488 21.7454 15.995 21.7454 23.3036C21.7454 27.6289 23.8277 31.4763 27.0427 33.8977C18.4348 37.1288 12.2915 45.443 12.2915 55.166H16.3931C16.3931 44.9057 24.7404 36.5589 35.0007 36.5589C45.2605 36.5589 53.6078 44.9057 53.6078 55.166H57.7094C57.7088 45.443 51.5661 37.1288 42.9576 33.8977ZM25.847 23.3036C25.847 18.2562 29.9528 14.1504 35.0002 14.1504C40.0475 14.1504 44.1534 18.2562 44.1534 23.3036C44.1534 28.351 40.0475 32.4574 35.0002 32.4574C29.9528 32.4574 25.847 28.351 25.847 23.3036Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_143_304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user-profile.59673304144541074d1f37194e999dea.svg";
export { ForwardRef as ReactComponent };